import { TagRequest } from '../../../TagRequest';

import {
  IAnalyticsConnectionMetadata,
  IAnalyticsExtConnectionSettings, IAnalyticsExtWorkbookId
} from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';
import { IGetItemsResult } from '../../../../types/IGetItemsResult';

export interface IGetAnalyticsConnectionOptionsForWorkbookResult extends IGetItemsResult {
  connectionMetadataList: IAnalyticsConnectionMetadata[];
}

export class GetAnalyticsConnectionOptionsForWorkbookRequest extends TagRequest<{}, IGetAnalyticsConnectionOptionsForWorkbookResult> {
  constructor(WorkbookId: IAnalyticsExtWorkbookId) {
    super('analyticsextensions', 'getConnectionOptionsForWorkbook', WorkbookId);
  }
}
